import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import PeriodTable from '../PeriodTable'

export const AdsReplacementDate = styled.div``

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 0 0 2rem 0;
`

export const Container = styled.div``

export const Top = styled.div`
  background-color: ${({ theme }) => theme.colors.bluePrimary};
  padding: 2.4rem 3rem;
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
  min-height: 6.8rem;
`

export const Subtitle = styled.h3`
  ${({ theme }) => theme.textStyles.firaSansTextBase};
  margin: 0;
  display: flex;
  flex-wrap: wrap;
`

export const SubtitleLabel = styled.span`
  ${({ theme }) => theme.textStyles.firaSansTextBaseSemiBold};
  color: ${({ theme }) => theme.colors.pureWhite};
  margin-right: 1rem;
`

export const RequestedDate = styled.span`
  ${({ theme }) => theme.textStyles.firaSansTextBase};
  color: ${({ theme }) => theme.colors.pureWhite};
`

export const Bottom = styled.div`
  padding: 2.4rem 3rem;
  border-left: 1px solid ${({ theme }) => theme.colors.greyContour};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyContour};
  border-right: 1px solid ${({ theme }) => theme.colors.greyContour};
  border-bottom-left-radius: 2rem;
  border-bottom-right-radius: 2rem;
  overflow: auto;

  @media ${mq(sizes.tablet)} {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
  }
`

export const PeriodsFrequencyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const Wrapper = styled.div`
  @media ${mq(null, sizes.tablet)} {
    margin-bottom: 1rem;
  }
`

export const Label = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBaseSemiBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 1rem;
`

export const Value = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};

  @media ${mq(sizes.tablet)} {
    margin-top: 1rem;
  }
`

export const TablePeriod = styled(PeriodTable)``
